import React from 'react';

import PropTypes from 'prop-types';

import { TextField } from '@mui/material';

const TextArea = ({
  value,
  onChange,
  placeholder,
  disabled,
  name,
  error,
  label,
  ...rest
}) => {
  return (
    <TextField
      sx={{ width: '100%' }}
      label={label && t(label)}
      name={name}
      onChange={onChange}
      value={value}
      disabled={disabled}
      placeholder={placeholder}
      multiline
      size='small'
      rows={4}
      {...rest}
    />
  );
};

// PropTypes za validaciju propsa
TextArea.propTypes = {
  value: PropTypes.string.isRequired,
  onChange: PropTypes.func.isRequired,
  placeholder: PropTypes.string,
  disabled: PropTypes.bool,
  error: PropTypes.bool,
};

TextArea.defaultProps = {
  placeholder: 'Unesite tekst...',
  disabled: false,
  error: false,
};

export default TextArea;
